'use strict';
((host)=>{
  const id=value=>{const n=Number(value);if(!Number.isSafeInteger(n)||n<1)throw Error('Ungültige Shopify-ID.');return n;};
  const dimension=value=>{
    const match=String(value).trim().match(/^(\d+(?:[.,]\d+)?)\s*[×x/]\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?$/i);
    if(!match)throw Error('Bestellmaß ist nicht eindeutig lesbar.');
    const values=match.slice(1).map(v=>Number(v.replace(',','.')));
    if(values.some(v=>!Number.isFinite(v)||v<=0))throw Error('Ungültiges Bestellmaß.');
    return values.join('/');
  };
  function build(products){
    const catalog=Object.create(null),globalVariants=new Set();
    for(const raw of products){
      const key=String(id(raw.id));if(Object.hasOwn(catalog,key))throw Error('Produkt mehrfach im Katalog gefunden. Bitte erneut laden.');
      const p={id:id(raw.id),title:String(raw.series||raw.title),productTitle:String(raw.title),page:raw.url,image:raw.image||null,frameNote:String(raw.frameNote||''),accessoryPolicy:raw.accessoryPolicy==='sr-only'?'sr-only':null,profiles:raw.profiles||[],variants:[],rows:[],error:null};catalog[key]=p;
      try{
        if(raw.truncated)throw Error('Dieses Produkt erreicht die Liquid-Variantengrenze. Bitte vor Verwendung vollständig anbinden.');
        if(!Array.isArray(raw.options)||raw.options.length!==2)throw Error('Für diese Matrix sind genau eine Maßoption und eine Ausführungsoption erforderlich.');
        const sizeIndex=raw.options.findIndex(o=>String(o.name).toLowerCase().replace(/\s/g,'')==='bestellmaß');
        if(sizeIndex<0)throw Error('Die Produktoption Bestellmaß fehlt.');
        const typeIndex=1-sizeIndex,sizeValues=raw.options[sizeIndex].values,typeValues=raw.options[typeIndex].values;
        p.optionTitle=String(raw.options[typeIndex].name);const sizes=new Set();
        p.rows=sizeValues.map(value=>{const size=dimension(value);if(sizes.has(size))throw Error('Bestellmaße sind nicht eindeutig.');sizes.add(size);return {size,rawSize:value,offers:[],prices:[],sr:null,lock:null};});
        p.variants=typeValues.map(value=>({code:String(value),title:String(value),detail:'',material:''}));
        if(!p.rows.length||!p.variants.length||new Set(typeValues).size!==typeValues.length)throw Error('Ausführungsoptionen fehlen oder sind doppelt.');
        const source=(raw.shopifyVariants||[]).map(v=>{
          const variantId=id(v.id);if(globalVariants.has(variantId))throw Error('Varianten-ID mehrfach gefunden.');globalVariants.add(variantId);
          if(!Array.isArray(v.options)||v.options.length!==2||typeof v.available!=='boolean'||!Number.isSafeInteger(v.price)||v.price<0)throw Error('Variantendaten sind unvollständig.');
          let sr=null;
          if(v.sr){
            try{
              const a=v.sr;
              if(!raw.safetyFrameProduct||id(a.productId)===p.id||id(a.id)===variantId||id(a.productId)!==id(raw.safetyFrameProduct.id)||dimension(a.size)!==dimension(v.options[sizeIndex])||typeof a.available!=='boolean'||!Number.isSafeInteger(a.price)||a.price<0)throw Error();
              sr={id:id(a.id),productId:id(a.productId),title:String(raw.safetyFrameProduct.title),size:dimension(a.size),price:a.price,available:a.available};
            }catch{sr={available:false,error:'Der Sicherheitsrahmen ist nicht eindeutig zugeordnet.'};}
          }
          let accessories=[];
          if(p.accessoryPolicy!=='sr-only')try{
            const allowed=new Map((raw.accessoryProducts||[]).map(a=>[id(a.id),String(a.title)])),seen=new Set();
            if(!Array.isArray(v.accessories??[])||(v.accessories||[]).length>40)throw Error();
            accessories=(v.accessories||[]).map(a=>{
              const aid=id(a.id),pid=id(a.productId);
              if(!allowed.has(pid)||pid===p.id||pid===raw.safetyFrameProduct?.id||aid===variantId||aid===sr?.id||seen.has(aid)||typeof a.available!=='boolean'||!Number.isSafeInteger(a.price)||a.price<0||(a.size&&dimension(a.size)!==dimension(v.options[sizeIndex])))throw Error();
              seen.add(aid);return {id:aid,productId:pid,title:allowed.get(pid),variantTitle:String(a.variantTitle||''),price:a.price,available:a.available};
            });
          }catch{accessories=[];}
          return {...v,id:variantId,sr,accessories};
        });
        for(const row of p.rows){
          row.offers=p.variants.map(column=>{
            const matches=source.filter(v=>v.options[sizeIndex]===row.rawSize&&v.options[typeIndex]===column.code);
            if(matches.length>1)throw Error('Mehrere Varianten für dieselbe Kombination gefunden.');
            return matches[0]||null;
          });row.prices=row.offers.map(v=>v?.available?v.price:null);
        }
        for(let j=0;j<p.variants.length;j++){
          const profiles=p.rows.map(r=>r.offers[j]?.profile).filter(Boolean),unique=new Set(profiles.map(v=>v.id));
          if(unique.size===1){p.variants[j].profile=profiles[0];p.variants[j].detail=String(profiles[0].aufbau||'');}
          else if(unique.size>1)p.variants[j].detail='Technische Angaben unterscheiden sich nach Bestellmaß.';
        }
      }catch(error){p.error=error.message;p.rows=[];p.variants=[];}
    }
    return catalog;
  }
  async function load(root,signal,{fresh=false}={}){
    let payload=fresh?null:root.querySelector('[data-ks-catalog-page]');
    if(!payload){
      const endpoint=new URL(root.dataset.catalogUrl,location.origin);
      if(endpoint.origin!==location.origin)throw Error('Ungültige Katalogadresse.');
      endpoint.searchParams.set('section_id','ks-matrix-katalog');
      endpoint.searchParams.delete('preview_theme_id');
      if(root.dataset.preview==='true')endpoint.searchParams.set('preview_theme_id',root.dataset.themeId);
      const response=await fetch(endpoint,{signal,credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}});
      if(!response.ok)throw Error('Produktliste konnte nicht geladen werden. Bitte erneut versuchen.');
      const document=new DOMParser().parseFromString(await response.text(),'text/html');
      payload=document.querySelector('[data-ks-catalog-page]');
    }
    if(!payload)throw Error('Produktzugriff nicht freigegeben. Bitte Anmeldung und Shopansicht prüfen.');
    const result=JSON.parse(payload.textContent);
    if(result.scope!==root.dataset.scope||String(result.themeId)!==root.dataset.themeId)throw Error('Produktliste gehört nicht zum aktuellen Kunden- und Theme-Kontext. Bitte neu laden.');
    if(result.version!==1||!Array.isArray(result.products)||typeof result.error!=='string')throw Error('Ungültige Matrix-Produktliste. Bitte neu laden.');
    if(result.currency!==root.dataset.currency)throw Error('Währung hat sich geändert. Bitte neu laden.');
    if(result.error)throw Error(result.error);
    if(result.products.length>50)throw Error('Die Matrix-Produktliste überschreitet die unterstützte Grenze von 50 Produktreihen.');
    const catalog=build(result.products);
    for(const product of Object.values(catalog)){
      const url=new URL(product.page,location.origin);if(url.origin!==location.origin)throw Error('Ungültiges Produktziel.');
      url.searchParams.delete('view');url.searchParams.delete('preview_theme_id');if(root.dataset.preview==='true')url.searchParams.set('preview_theme_id',root.dataset.themeId);url.hash='ks-matrix-v2';product.page=url.pathname+url.search+url.hash;
    }
    return catalog;
  }
  const api={build,load,dimension};
  if(typeof module==='object'&&module.exports)module.exports=api;
  else host.KSMatrixCatalog=Object.freeze(api);
})(typeof globalThis==='object'?globalThis:this);
